<template>
  <el-dialog title="计算"
             :visible.sync="dialogVisible"
             custom-class="importDialog"
             :show-close="false"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             v-loading="loading">
    <el-form :model="form"
             :rules="rules"
             ref="refDialog"
             label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="profession"
                        label="行业">
            <el-select clearable
                       v-model="form.profession"
                       placeholder="请选择"
                       style="width: 90%">
              <el-option v-for="item in platlists"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="business"
                        label="商家">
            <el-select v-loading="ptnListLoading"
                       clearable
                       v-model="form.business"
                       placeholder="请选择"
                       style="width: 90%">
              <el-option v-for="item in ptnlists"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="store"
                        label="店铺">
            <el-select v-loading="shopListLoading"
                       clearable
                       v-model="form.store"
                       placeholder="请选择"
                       style="width: 90%">
              <el-option v-for="item in shoplists"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="文件名"
                        prop="filename">
            <el-input v-model="form.filename"
                      style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="付款时间"
                        prop="pay_time">
            <el-date-picker v-model="form.pay_time"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="备注">
            <el-input v-model="form.remark"
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4}"
                      style="width: 96%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="hide">取 消</el-button>
      <el-button type="primary"
                 @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getplatlists, getptnlists, getshoplists } from '@/common/mixins/select'
import * as Desc from './desc.js'
import { rules } from './data.js'
import { dealReturn } from '@/common/js'
export default {
  mixins: [getplatlists, getptnlists, getshoplists],
  data() {
    return {
      dialogVisible: false,
      form: { profession: '', business: '', store: '' },
      loading: false,
      rules,
      Desc,
      loading: false,
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
      this.form = { profession: '', business: '', store: '' }
      this.$refs.refDialog.resetFields()
    },
    submit() {
      let isValid
      this.$refs.refDialog.validate((valid) => {
        isValid = valid
      })
      if (!isValid) return

      let form = {
        seller_nick: this.form.store,
        input_filename: this.form.input_filename,
        start_date: this.form.pay_time[0],
        end_date: this.form.pay_time[1],
        remark: this.form.remark ? this.form.remark : '',
      }

      form = JSON.parse(JSON.stringify(form))
      delete form.profession
      delete form.business

      this.submitApi(form)
    },
    async submitApi(form) {
      this.loading = true
      let { data, err } = await this.axiosApi(this.Desc.reCompute_api, form)
      this.loading = false
      // console.log(data)
      if (data && data.data.meta.status === 200) {
        //
        // console.log('hide')
        this.hide()
      } else {
        // this.$message.error(err.response.data.message);
      }
      dealReturn(data, err)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper >>> {
  .importDialog {
    width: 800px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/buy-again/dialog.vue